import React from "react";

const resources = [
  {
    title: "PASSION",
    link: "https://docs.google.com/document/d/1oxr2E2kVP6zICzQQIaeVpix8DyPq7PwQ/"
  },
  {
    title: "EDUCATION ENTHRONES THE ORDINARY YOU",
    link: "https://docs.google.com/document/d/1AvexjZ9Rs0UtO36XgSvLfMu1p9xO8Bef/"
  },
  {
    title: "SUCCESS COMES AS MIRACLE",
    link: "https://docs.google.com/document/d/1YhRwmQpo2Eaiu_CWnSetR0R9-b4qo2ak/"
  },
  {
    title: "TOP 10 SECRET OF FIRST CLASS STUDENTS",
    link: "https://drive.google.com/file/d/1bgq3xXCeKv-6dv8RSfV60BJZqkcf-aJR/view?usp=sharing"
  },
  {
    title: "TOP 9 COMMONEST MISTAKES THAT STUDENTS MAKE WHEN SITTING FOR EXAMS", 
    link: "https://drive.google.com/file/d/1k85Q8ewapImPlgwYVxnHpgxPVhFE7oYv/view?usp=sharing"
  },
];

function Resources() {
  return (
    <section style={styles.container}>
      <h1 style={styles.title}>Articles</h1>

      <div style={styles.grid}>
        {resources.map((item, index) => (
          <div key={index} style={styles.card}>
            <h3 style={styles.topic}>{item.title}</h3>

            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <button style={styles.btn}>Open</button>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "80px 20px",
    textAlign: "center"
  },
  title: {
    fontSize: "32px",
    marginBottom: "40px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px"
  },
  card: {
    background: "#f9f9f9",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
  },
  topic: {
    marginBottom: "15px"
  },
  btn: {
    padding: "10px 20px",
    background: "#163e66",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  }
};

export default Resources;